import { Button } from "@/components/ui/button";
import {
	Dialog,
	DialogContent,
	DialogFooter,
	DialogTitle,
} from "@/components/ui/dialog";

function CancelSubscriptionDialog({
	showCancelSubscriptionDialog,
	setShowCancelSubscriptionDialog,
	onCancelSubscription,
}: {
	showCancelSubscriptionDialog: boolean;
	setShowCancelSubscriptionDialog: (open: boolean) => void;
	onCancelSubscription: () => void;
}) {
	return (
		<Dialog
			open={showCancelSubscriptionDialog}
			onOpenChange={setShowCancelSubscriptionDialog}
		>
			<DialogContent className="p-10">
				<DialogTitle>Cancel Subscription</DialogTitle>
				<span className="web-body-b1">
					Are you sure you want to cancel your subscription? Cancellation will
					take effect at the end of your current billing period. You will{" "}
					<span className="font-bold">lose</span> all accumulated entries.
				</span>

				<DialogFooter className="gap-4">
					<Button
						variant={"secondary"}
						className="w-full md:w-50"
						onClick={() => setShowCancelSubscriptionDialog(false)}
					>
						Cancel
					</Button>
					<Button className="w-full md:w-50" onClick={onCancelSubscription}>
						Confirm
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
}

export default CancelSubscriptionDialog;
